"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Bus", {
  enumerable: true,
  get: function get() {
    return _Bus["default"];
  }
});
Object.defineProperty(exports, "connectSize", {
  enumerable: true,
  get: function get() {
    return _connectSize["default"];
  }
});
Object.defineProperty(exports, "createSurface", {
  enumerable: true,
  get: function get() {
    return _createSurface["default"];
  }
});
Object.defineProperty(exports, "listSurfaces", {
  enumerable: true,
  get: function get() {
    return _createSurface.list;
  }
});
Object.defineProperty(exports, "GLSL", {
  enumerable: true,
  get: function get() {
    return _GLSL["default"];
  }
});
Object.defineProperty(exports, "LinearCopy", {
  enumerable: true,
  get: function get() {
    return _LinearCopy["default"];
  }
});
Object.defineProperty(exports, "NearestCopy", {
  enumerable: true,
  get: function get() {
    return _NearestCopy["default"];
  }
});
Object.defineProperty(exports, "Node", {
  enumerable: true,
  get: function get() {
    return _Node["default"];
  }
});
Object.defineProperty(exports, "Shaders", {
  enumerable: true,
  get: function get() {
    return _Shaders["default"];
  }
});
Object.defineProperty(exports, "Uniform", {
  enumerable: true,
  get: function get() {
    return _Uniform["default"];
  }
});
Object.defineProperty(exports, "Visitor", {
  enumerable: true,
  get: function get() {
    return _Visitor["default"];
  }
});
Object.defineProperty(exports, "VisitorLogger", {
  enumerable: true,
  get: function get() {
    return _VisitorLogger["default"];
  }
});
Object.defineProperty(exports, "Visitors", {
  enumerable: true,
  get: function get() {
    return _Visitors["default"];
  }
});
exports.Backbuffer = void 0;

var _Bus = _interopRequireDefault(require("./Bus"));

var _connectSize = _interopRequireDefault(require("./connectSize"));

var _createSurface = _interopRequireWildcard(require("./createSurface"));

var _GLSL = _interopRequireDefault(require("./GLSL"));

var _LinearCopy = _interopRequireDefault(require("./LinearCopy"));

var _NearestCopy = _interopRequireDefault(require("./NearestCopy"));

var _Node = _interopRequireDefault(require("./Node"));

var _Shaders = _interopRequireDefault(require("./Shaders"));

var _Uniform = _interopRequireDefault(require("./Uniform"));

var _Visitor = _interopRequireDefault(require("./Visitor"));

var _VisitorLogger = _interopRequireDefault(require("./VisitorLogger"));

var _Visitors = _interopRequireDefault(require("./Visitors"));

require("webgltexture-loader-ndarray");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // DEPRECATED


var Backbuffer = "Backbuffer";
exports.Backbuffer = Backbuffer;